import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "addButton", "chip", "chipName", "chipLabel"]
  static values = { max: Number }

  chipTargetConnected() { this.refresh() }
  chipTargetDisconnected() { this.refresh() }

  fill() {
    const name = this.inputTarget.value.trim()
    if (name === "") return this.chipTargets.at(-1).remove()

    this.chipNameTargets.at(-1).value = name
    this.chipLabelTargets.at(-1).textContent = name
    this.inputTarget.value = ""
    this.inputTarget.focus()
  }

  refresh() {
    const limitReached = this.activeChips.length >= this.maxValue

    this.inputTarget.disabled = limitReached
    this.addButtonTarget.disabled = limitReached
  }

  get activeChips() {
    return this.chipTargets.filter((chip) => getComputedStyle(chip).display !== "none")
  }
}
